import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";
import { formatDateRange } from "../../utils/formatDate";

const mapField = (item) => {
  return {
    ...item,
    id: _.get(item, "id"),
    name: _.get(item, "name"),
    description: _.reduce(
      _.get(item, "description"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value),
        };
      },
      {}
    ),
    date: formatDateRange(
      _.get(item, "event_start_time"),
      _.get(item, "event_end_time")
    ),
    image: _.get(item, "image.full_file_path"),
    // images: _.map(_.get(item, "images"), image => image.full_file_path),
    category_id: _.get(item, "category_id"),
    website_url: _.get(item, "website_url"),
  };
};

const fetchEventApi = () => {
  return fetchApi("events")
    .then((res) => _.get(res, "data"))
    .then((items) => _.map(items, mapField));
};

export { fetchEventApi };



// WEBPACK FOOTER //
// ./src/services/page/event.js